import {useRef, useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/helpers-css-strings";
import {CrmFlagIcon, DotsVerticalIcon} from "@pg-design/icons-module";

import {useClickOutside} from "../../hooks/handle_click_outside";
import {ReportContentModal} from "./ReportContentModal";

interface IProps {
    className?: string;
    onToggle?: (isOpen: boolean) => void;
}

export const DetailHeaderDropdownMenu = (props: IProps) => {
    const {className, onToggle} = props;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);

    const wrapperRef = useRef<HTMLDivElement>(null);

    useClickOutside(wrapperRef, () => setIsMenuOpen(false));

    const handleToggle = () => {
        setIsMenuOpen((prev) => !prev);
        if (onToggle) {
            onToggle(isMenuOpen);
        }
    };

    return (
        <>
            <div className={cx(menuWrap, className)} onClick={handleToggle} ref={wrapperRef}>
                <Button variant="none_secondary" className={menuButton} size="x-small">
                    <DotsVerticalIcon size="2.2" wrapperColor="transaprent" wrapperSize="2.2" />
                </Button>

                {isMenuOpen && (
                    <div className={buttonWrap}>
                        <Button variant="none_secondary" iconLeft={CrmFlagIcon} onClick={() => setIsReportModalOpen(true)} className={itemButton}>
                            Zgłoś treść
                        </Button>
                    </div>
                )}
            </div>

            <ReportContentModal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} />
        </>
    );
};

const menuWrap = css({
    position: "relative"
});

const menuButton = css({
    maxWidth: "40px",
    position: "relative",
    boxShadow: elevation(1)
});

const buttonWrap = css({
    p: 2,
    backgroundColor: "var(--colors-white)",
    borderRadius: 1,
    position: "absolute",
    right: 0,
    bottom: "-2.5rem",
    transform: "translateY(100%)",
    zIndex: 12,
    boxShadow: elevation(4)
});

const itemButton = css({
    p: "1.5rem 2rem",
    height: "6rem"
});
import {useRef, useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/helpers-css-strings";
import {CrmFlagIcon, DotsVerticalIcon} from "@pg-design/icons-module";

import {useClickOutside} from "../../hooks/handle_click_outside";
import {ReportContentModal} from "./ReportContentModal";

interface IProps {
    className?: string;
    onToggle?: (isOpen: boolean) => void;
}

export const DetailHeaderDropdownMenu = (props: IProps) => {
    const {className, onToggle} = props;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);

    const wrapperRef = useRef<HTMLDivElement>(null);

    useClickOutside(wrapperRef, () => setIsMenuOpen(false));

    const handleToggle = () => {
        setIsMenuOpen((prev) => !prev);
        if (onToggle) {
            onToggle(isMenuOpen);
        }
    };

    return (
        <>
            <div className={cx(menuWrap, className)} onClick={handleToggle} ref={wrapperRef}>
                <Button variant="none_secondary" className={menuButton} size="x-small">
                    <DotsVerticalIcon size="2.2" wrapperColor="transaprent" wrapperSize="2.2" />
                </Button>

                {isMenuOpen && (
                    <div className={buttonWrap}>
                        <Button variant="none_secondary" iconLeft={CrmFlagIcon} onClick={() => setIsReportModalOpen(true)} className={itemButton}>
                            Zgłoś treść
                        </Button>
                    </div>
                )}
            </div>

            <ReportContentModal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} />
        </>
    );
};

const menuWrap = css({
    position: "relative"
});

const menuButton = css({
    maxWidth: "40px",
    position: "relative",
    boxShadow: elevation(1)
});

const buttonWrap = css({
    p: 2,
    backgroundColor: "var(--colors-white)",
    borderRadius: 1,
    position: "absolute",
    right: 0,
    bottom: "-2.5rem",
    transform: "translateY(100%)",
    zIndex: 12,
    boxShadow: elevation(4)
});

const itemButton = css({
    p: "1.5rem 2rem",
    height: "6rem"
});
